import React from "react";
import { css } from "emotion";
import { Component } from "preact";
import { max } from "../../utils/CssUtils";

const leftButton = require("../../assets/ic_left-button.svg");
const rightButton = require("../../assets/ic_right-button.svg");

const wrapper = css({
  position: "relative"
});

const sliderContainer = css({
  display: "flex",
  overflowY: "hidden",
  overflowX: "scroll",
  whiteSpace: "nowrap",
  scrollBehavior: "smooth",
  padding: "10px 0"
});

const button = css({
  [max(768)]: {
    display: "none"
  },
  borderRadius: "100%",
  position: "absolute",
  top: "calc(50% - 40px)",
  width: 70,
  height: 70,
  zIndex: 1,
  cursor: "pointer",
  color: "inherit",
  border: "none",
  font: "inherit",
  outline: "inherit"
});

const item = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: "transparent",
  borderRadius: 8
});

class Slider extends Component {
  constructor(props) {
    super(props);

    let { hideButtons = true } = this.props;

    this.state = {
      hideLeftButton: true,
      hideRightButton: hideButtons
    };
  }

  checkHideButtons = () => {
    if (!this.slider) {
      return;
    }

    let left = false,
      right = false;

    if (this.slider.scrollLeft == 0) {
      left = true;
    }

    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

    if (this.slider.scrollLeft == maxScrollLeft) {
      right = true;
    }

    this.setState({
      hideLeftButton: left,
      hideRightButton: right
    });
  };

  scrollLeft = () => {
    this.slider.scrollLeft -= 180;
  };

  scrollRight = () => {
    this.slider.scrollLeft += 180;
  };

  render() {
    const {
      gap = 0,
      mobileGap = gap,
      children,
      hideButtons = true
    } = this.props;

    const prev = css({
      display: this.state.hideLeftButton ? "none" : "inherit",
      left: -38,
      backgroundImage: `url('${leftButton}')`
    });

    const next = css({
      display: this.state.hideRightButton ? "none" : "inherit",
      right: -40,
      backgroundImage: `url('${rightButton}')`
    });

    const gapStyles = css({
      marginRight: gap,
      [max(600)]: {
        marginRight: mobileGap
      }
    });

    return (
      <div className={wrapper}>
        <div
          ref={slider => (this.slider = slider)}
          className={sliderContainer}
          onScroll={hideButtons ? null : this.checkHideButtons}
        >
          <button
            className={css([prev, button])}
            onClick={this.scrollLeft}
            aria-label="previous"
          />
          {React.Children.map(children, child => (
            <div className={css([item, gapStyles])}>{child}</div>
          ))}
          <button
            className={css([next, button])}
            onClick={this.scrollRight}
            aria-label="next"
          />
        </div>
      </div>
    );
  }
}

export default Slider;
